import React, { useContext } from "react";
import product1 from "../../assets/demo_product1.jpg";
import product2 from "../../assets/demo_product2.jpg";
import product3 from "../../assets/demo_product3.jpg";
import product4 from "../../assets/demo_product4.jpg";
import product5 from "../../assets/demo_product5.jpg";
import product6 from "../../assets/demo_product6.jpg";
import i18next from "i18next";
import { domainProvider } from "../../contexts/DomainContext";
import { Link } from "react-router-dom";
import { BsCart2 } from "react-icons/bs";
import Div from "../../components/utils/Div";

const demoProductArray = [
  {
    product_price: "100",
    thumbnail_image: product1,
    product_name: "Man Puffer Jacket",
  },
  {
    product_price: "300",
    thumbnail_image: product2,
    product_name: "Black Jacket",
  },
  {
    product_price: "500",
    thumbnail_image: product3,
    product_name: "Short Sleeve Green Tshirt",
  },
  {
    product_price: "1000",
    thumbnail_image: product4,
    product_name: "Short Sleeve Tshirt",
  },
  {
    product_price: "1000",
    thumbnail_image: product5,
    product_name: "Man's Brown Blazer",
  },
  {
    product_price: "1000",
    thumbnail_image: product6,
    product_name: "Man's Blazer",
  },
  {
    product_price: "1000",
    thumbnail_image: product4,
    product_name: "Short Sleeve Tshirt",
  },
  {
    product_price: "1000",
    thumbnail_image: product4,
    product_name: "Short Sleeve Tshirt",
  },
];

const FeatherProduct = ({ products, storeName }) => {
  const selectLanguage = i18next.language;
  const { customdomain } = useContext(domainProvider);

  return (
    <Div>
      {products.length > 0 ? (
        <div className=" mb-12">
          <div className="px-5">
            <p className="text-violet-700 text-center mb-3 font-bold">
              {selectLanguage == "ar"
                ? "أهم مبيعات هذا الأسبوع"
                : "TOP SALE ON THIS WEEK"}
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-pink-500 text-center mb-6 font-poppin">
              {selectLanguage == "ar"
                ? "المنتجات المميزة"
                : "Featured Products"}
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {products.map((item, idx) => (
                <div
                  className=" relative cursor-pointer bg-white  shadow-md hover:shadow-lg transition-transform duration-300 hover:scale-[1.02] max-w-[360px] w-full"
                  key={idx}
                >
                  {/* Price Tag */}
                  <div className="absolute top-3 right-3 bg-white text-gray-800 px-3 py-1 text-sm rounded-md shadow-md hover:bg-black hover:text-primary transition-colors duration-300">
                    <p>{item.product_price} ر.س</p>
                  </div>

                  {/* Product Image */}
                  <div className="w-full overflow-hidden ">
                   
                    <Link to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/product_details/${item.product_id}`
                      : `/product_details/${item.product_id}`
                      }`} className="block w-full h-[200px] md:h-[300px] overflow-hidden">
                      <img
                        src={item.thumbnail_image}
                        alt={
                          selectLanguage == "ar" && item.product_name_ar
                            ? item.product_name_ar
                            : item.product_name
                        }
                           className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                      />
                    </Link>
                  </div>

                  {/* Product Content */}
                  <div className="p-2 md:p-4 text-center">
                    {/* Product Title */}
                    <h2 className="text-gray-800 text-[16px] font-semibold  line-clamp-2">
                      <Link
                        to={`${customdomain === "aitech.com.sa"
                          ? `/${storeName}/product_details/${item.product_id}`
                          : `/product_details/${item.product_id}`
                          }`}
                        className="text-gray-700 font-semibold text-lg line-clamp-2 hover:text-blue-600 transition-all"
                      >
                        {selectLanguage == "ar" && item.product_name_ar
                          ? item.product_name_ar
                          : item.product_name}
                      </Link>
                    </h2>

                    {/* Price + Cart Action */}
                    <div className=" flex flex-col items-center gap-2">
                      <p className="text-lg font-bold text-gray-700">{item.product_price} ر.س</p>
                      <Link
                        to={`${customdomain === "aitech.com.sa"
                          ? `/${storeName}/product_details/${item.product_id}`
                          : `/product_details/${item.product_id}`
                          }`}
                        className="inline-flex items-center gap-2  text-white text-sm px-4 py-2 rounded-md bg-[#F97316] hover:bg-[#F97316] transition-all duration-300"
                      >
                        <BsCart2
                          className={`text-lg ${selectLanguage === "ar" ? "ml-2" : "mr-2"
                            }`}
                        />
                     <span className="hidden md:block">   {selectLanguage === "ar" ? "إضافة إلى السلة" : "Add to cart"}</span>
                      </Link>
                    </div>
                  </div>
                </div>

              ))}
            </div>

            <div className="flex justify-center content-center mt-12">
              <Link
                to={`${customdomain === "aitech.com.sa"
                  ? `/${storeName}/shop`
                  : `/shop`
                  }`}
              >
                <button
                  className={` text-white px-10 py-3 rounded-full text-xl bg-[#F97316] hover:bg-[#F97316] transition duration-300 ease-in-out `}
                >
                  {selectLanguage == "ar" ? "تسوق الآن" : "Shop Now"}
                </button>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className=" mb-12">
          <div className="px-5">
            <p className="text-violet-700 text-center mb-3 font-bold">
              {selectLanguage == "ar" ? "منتج افتراضي" : "Default Product"}
            </p>
            <h2 className="text-2xl md:text-4xl font-bold font-domain text-pink-500 text-center mb-6">
              {selectLanguage == "ar" ? "المنتجات التجريبية" : "Demo products"}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 my-12 font-domain">
              {demoProductArray.map((item, idx) => (
                <div
                  className="single_product relative cursor-pointer"
                  key={idx}
                >
                  <div className="absolute top-0 right-0 p-3 bg-white hover:bg-black hover:text-primary heart">
                    <p>{item.product_price} ر.س</p>
                  </div>
                  <div className="w-full h-[367px]">
                    {/* <Link
                      to={`${
                        customdomain === "aitech.com.sa"
                          ? `/${storeName}/product_details/sample-product`
                          : `/product_details/sample-product`
                      }`}
                      className="text-center text-gray-400"
                    > */}
                    <img
                      className="w-full h-full object-cover"
                      src={item.thumbnail_image}
                      alt={item.product_name}
                    />
                    {/* </Link> */}
                  </div>
                  <div className="">
                    <h2 className="card-title justify-center hover:text-blue-500 text-[14px] my-3 text-gray-600 text-base capitalize">
                      {item.product_name}
                    </h2>
                    <div className="card-actions justify-center items-center flex-col hidden hover:block lg:overflow-hidden lg:h-[20px]">
                      <div className="transition-all ease-in duration-300 text-blue-700 hover:text-blue-700 flex items-center price text-center">
                        <p>{item.product_price} ر.س</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Div>
  );
};

export default FeatherProduct;
